import { getContext, invoke } from './core';
import { bridgeConfigDelegates } from './bridge-config-delegates';
import { fetchProduct, type FetchProductPayload, type FetchProductResponse } from './fetchProduct';
import { on, emit } from './events';
import { onPublic, emitPublic } from './publicEvents';
import type { ForgeDoc } from '@atlassian/forge-ui-types';
import type { FlagOptions } from '../../custom-ui';
import type { ViewContext } from '../../custom-ui/iframe/types';
import type { BridgeContext, BridgeServices } from '../types';
import type { TBridgeMethod } from './types';
import type { SubscriptionHandle } from './utils';

export const bridgeMethods: {
    // Core methods
    getContext: TBridgeMethod<Pick<BridgeContext, "viewContext">, void, ViewContext>; invoke: TBridgeMethod<Pick<BridgeContext, "resolverContext" | "extensionPayload"> & {
        services: Pick<BridgeServices, "invoker" | "getContextToken" | "tracing" | "onThreeLO">;
    }, {
        functionKey: string;
        payload: object;
    }, object>; fetchProduct: TBridgeMethod<Pick<BridgeContext, never> & {
        services: Pick<BridgeServices, "productFetchClient">;
    }, FetchProductPayload, FetchProductResponse>;
    // Event methods
    on: TBridgeMethod<Pick<BridgeContext, "extension" | "extensionDetails" | "registerCleanup">, {
        callback: (payload?: any) => Promise<any>;
        event: string;
    }, SubscriptionHandle>; emit: TBridgeMethod<Pick<BridgeContext, "extensionDetails">, {
        event: string;
        payload?: any;
    }, void>;
    // Public event methods
    onPublic: TBridgeMethod<Pick<BridgeContext, "extensionDetails" | "registerCleanup">, {
        callback: (payload?: any) => Promise<any>;
        event: string;
    }, SubscriptionHandle>; emitPublic: TBridgeMethod<Pick<BridgeContext, "extensionDetails" | "contextIds"> & {
        services: Pick<BridgeServices, "relayEnvironment">;
    }, {
        event: string;
        payload?: any;
    }, void>; changeWindowTitle: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, string>; close: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, void>; closeFlag: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, Pick<FlagOptions, "id">>; emitReadyEvent: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, void>; onClose: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, void>; onError: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, {
        error: Error;
    }>; open: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, void>; openModal: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, any>; reconcile: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, {
        forgeDoc: ForgeDoc;
    }>; refresh: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, void>; showFlag: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, FlagOptions>; submit: TBridgeMethod<Pick<BridgeContext, "bridgeConfig">, void>;
} = {
	...bridgeConfigDelegates,
	// Core methods
	getContext,
	invoke,
	fetchProduct,
	// Event methods
	on,
	emit,
	// Public event methods
	onPublic,
	emitPublic,
};
